<template>
  <custom-dialog
    width="1280px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :append-to-body="true"
    class="account-rest-details-dialog"
  >
    <div
      class="dialog-body"
      style="padding-top: 0 !important;"
    >
      <div class="query-filter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('rest_details_dialog.jiao_yi_shi_jian') }}</div>
                <div class="value">
                  <custom-date-picker
                    v-model="formSearch.gmtCreate"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="—"
                    :start-placeholder="$t('rest_details_dialog.kai_shi_shi_jian')"
                    :end-placeholder="$t('rest_details_dialog.jie_shu_shi_jian')"
                    @change="onDateChange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  ></custom-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('rest_details_dialog.shou_kuan_gong_si') }}</div>
                <div class="value">
                  <custom-select
                    url="partnerBalanceReceivableOrgList"
                    v-model="formSearch.receivableOrgId"
                    :props="{label: 'label', value: 'value'}"
                    @change="onReceivableOrgChange"
                    @getList="onGetList"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              closable
              v-for="dateTag in dateTagList"
              :key="dateTag.value"
              @close="onCloseTime(dateTag.value)"
            >{{dateTag.label}}</el-tag>
            <el-tag
              closable
              v-for="receivableOrgTag in receivableOrgTagList"
              :key="receivableOrgTag.value"
              @close="onCloseReceivableOrg(receivableOrgTag.value)"
            >{{receivableOrgTag.label}}</el-tag>
            <el-button
              type="info"
              size="mini"
              @click="onClear"
            >{{ $t('Common.com_clear') }}</el-button>
          </div>
        </div>
      </div>
      <!-- <div class="search-content">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
        </el-form>
      </div> -->
      <div class="table-bd">
        <custom-table
          tableCode="portal_rest_details"
          height="400px"
          :stripe="true"
          :data="tableList"
          @column="setColumn"
          columnRef="column"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['accountRest', 'changeAmount']"
        >
          <template v-slot:accountRest="scope">
            <span>{{getAccountRest(scope.row)}}</span>
          </template>
          <template v-slot:changeAmount="scope">
            <span>{{formatChangeAmount(scope.row)}}</span>
          </template>
        </custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
          radius
        ></custom-pagination>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="info"
        @click="closeDialog"
      >{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  name: 'restDetailsDialog',
  mixins: [dialogMixins],
  components: {},
  data() {
    return {
      formSearch: {
        gmtCreate: '',
        receivableOrgId: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: null,
      dateTagList: [],
      receivableOrgTagList: [],
      receivableOrgList: [],
      tableList: [],
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    formatChangeAmount(row) {
      if (row.changeAmount > 0) {
        return `+${row.changeAmount}`;
      }
      return row.changeAmount;
    },
    getAccountRest(row) {
      const { currentAmount = 0, changeAmount = 0 } = row;
      return currentAmount - changeAmount;
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
    },
    onGetList(list) {
      this.receivableOrgList = list;
    },
    onReceivableOrgChange() {
      if (this.formSearch.receivableOrgId) {
        const item = this.receivableOrgList.find(obj => obj.value === this.formSearch.receivableOrgId);
        this.receivableOrgTagList = [item];
      } else {
        this.receivableOrgTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseReceivableOrg() {
      this.formSearch.receivableOrgId = '';
      this.receivableOrgTagList = [];
      this.onPageChange({ page: 1 });
    },
    onDateChange() {
      const data = this.formSearch.gmtCreate;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.dateTagList = [
          {
            label: `${start}-${end}`,
            value: 'date'
          }
        ];
      } else {
        this.dateTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseTime() {
      this.formSearch.gmtCreate = [];
      this.dateTagList = [];
      this.onDateChange();
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      const reqData = {
        ...this.formSearch,
        payableOrgId: this.userInfo.rootOrgId
      };
      // if (this.formSearch.gmtCreate && this.formSearch.gmtCreate.length) {
      //   const startDate = this.$moment(this.formSearch.gmtCreate[0]).format('YYYY-MM-DD HH:mm:ss');
      //   const endDate = this.$moment(this.formSearch.gmtCreate[1]).format('YYYY-MM-DD HH:mm:ss');
      //   reqData.gmtCreate = [startDate, endDate];
      // } else {
      //   reqData.gmtCreate = [];
      // }

      const reqUrl = apis.partnerBalanceRecordPage;
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    onClear() {
      this.formSearch.gmtCreate = [];
      this.dateTagList = [];
      this.formSearch.receivableOrgId = '';
      this.receivableOrgTagList = [];
      this.onPageChange({ page: 1 });
    }
  },
};
</script>

<style lang="scss">
.account-rest-details-dialog {
  .custom-pagination {
    padding-bottom: 0 !important;
  }
}
</style>
